import styled from 'styled-components';

export const P = styled.p`
  margin: 0;
  padding: 0.5rem 0;
  font-size: 1rem;
`;

export const Header = styled.b``;

export const Subheader = styled.div``;
